export default {"src":"/_next/static/media/iconCheck.65058350.svg","height":21,"width":22,"blurWidth":0,"blurHeight":0};